import './play.css';
import { Say } from "../widgets/Say";
import { PlayUrl } from './PlayUrl';

/** test palatalization */
export function Palatalization() {
  return (<>
    <h2>Palatalization</h2>

    <ul>
      <li><Say>[ˈpʲa]</Say>, <Say>[ˈpʲo]</Say>, <Say>[ˈpʲu]</Say>, <Say>[ˈpʲi]</Say>, <Say>[ˈpʲɛ]</Say>, <Say>[ˈpʲə]</Say></li>
      <li><Say>[ˈpʲa]</Say>, <Say>[ˈbʲa]</Say>, <Say>[ˈtʲa]</Say>, <Say>[ˈdʲa]</Say>, <Say>[ˈkʲa]</Say>, <Say>[ˈgʲa]</Say></li>
      <li><Say>[ˈmʲa]</Say>, <Say>[ˈnʲa]</Say>, <Say>[ˈŋʲa]</Say></li>
      <li><Say>[ˈrʲa]</Say>, <Say>[ˈɾʲa]</Say>, <Say>[ˈɽʲa]</Say></li>
      <li><Say>[ˈtsʲa]</Say>, <Say>[ˈt̠ʃʲa]</Say>, <Say>[ˈd̠ʒʲa]</Say></li>
      <li><Say>[ˈfʲa]</Say>, <Say>[ˈvʲa]</Say>, <Say>[ˈθʲa]</Say>, <Say>[ˈðʲa]</Say>, <Say>[ˈsʲa]</Say>, <Say>[ˈzʲa]</Say></li>
      <li><Say>[ˈɬʲa]</Say>, <Say>[ˈʋʲa]</Say>, <Say>[ˈɹʲa]</Say></li>
      <li><Say>[ˈlʲa]</Say>, <Say>[ˈɭʲa]</Say>, <Say>[ˈɫʲa]</Say></li>
      <li><Say>[['s;a]]</Say>, <Say>[['s.a]]</Say>, <Say>[['S;a']]</Say></li>
      <li><Say>[['z;a]]</Say>, <Say>[['z.a]]</Say>, <Say>[['Z;a']]</Say></li>
    </ul>

    <ul>
      <li><Say>[ˈapʲ]</Say>, <Say>[ˈabʲ]</Say>, <Say>[ˈatʲ]</Say>, <Say>[ˈadʲ]</Say>, <Say>[ˈakʲ]</Say>, <Say>[ˈagʲ]</Say></li>
      <li><Say>[ˈamʲ]</Say>, <Say>[ˈanʲ]</Say>, <Say>[ˈaŋʲ]</Say></li>
      <li><Say>[ˈarʲ]</Say>, <Say>[ˈaɾʲ]</Say>, <Say>[ˈaɽʲ]</Say></li>
      <li><Say>[ˈatsʲ]</Say>, <Say>[ˈat̠ʃʲ]</Say>, <Say>[ˈad̠ʒʲ]</Say></li>
      <li><Say>[ˈafʲ]</Say>, <Say>[ˈavʲ]</Say>, <Say>[ˈaθʲ]</Say>, <Say>[ˈaðʲ]</Say>, <Say>[ˈasʲ]</Say>, <Say>[ˈazʲ]</Say></li>
      <li><Say>[ˈaɬʲ]</Say>, <Say>[ˈaʋʲ]</Say>, <Say>[ˈaɹʲ]</Say></li>
      <li><Say>[ˈalʲ]</Say>, <Say>[ˈaɭʲ]</Say>, <Say>[ˈaɫʲ]</Say></li>
    </ul>

    <ul>
      <li><Say>[['apj]]</Say>, <Say>[['abj]]</Say>, <Say>[['atj]]</Say>, <Say>[['adj]]</Say>, <Say>[['akj]]</Say>, <Say>[['agj]]</Say></li>
      <li><Say>[['amj]]</Say>, <Say>[['anj]]</Say>, <Say>[['aNj]]</Say></li>
      <li><Say>[['aRj]]</Say>, <Say>[['a*j]]</Say>, <Say>[['ar.j]]</Say></li>
      <li><Say>[['atsj]]</Say>, <Say>[['atSj]]</Say>, <Say>[['adZj]]</Say></li>
      <li><Say>[['afj]]</Say>, <Say>[['avj]]</Say>, <Say>[['aTj]]</Say>, <Say>[['aDj]]</Say>, <Say>[['asj]]</Say>, <Say>[['azj]]</Say></li>
      <li><Say>[['al#j]]</Say>, <Say>[['av#j]]</Say>, <Say>[['arj]]</Say></li>
      <li><Say>[['alj]]</Say>, <Say>[['al.j]]</Say>, <Say>[['aLj]]</Say></li>
    </ul>

    explicit support in some cases:
    <ul>
      <li><Say>[[sas]]</Say>, <Say>[[s;as;]]</Say>         - <Say>[sas]</Say>, <Say>[sʲasʲ]</Say>, <Say>[ʂaʂ]</Say></li>
      <li><Say>[[zaz]]</Say>, <Say>[[z;az;]]</Say>         - <Say>[zaz]</Say>, <Say>[zʲazʲ]</Say>, <Say>[ʑaʑ]</Say></li>
      <li><Say>[[SaS]]</Say>, <Say>[[S;aS;]]</Say>         - <Say>[ʃaʃ]</Say>, <Say>[ʃʲaʃʲ]</Say>, <Say>[ɕaɕ]</Say></li>
      <li><Say>[[ZaZ]]</Say>, <Say>[[Z;aZ;]]</Say>         - <Say>[ʒaʒ]</Say>, <Say>[ʒʲaʒʲ]</Say>, <Say>[ʑaʑ]</Say></li>
      <li><Say>[[t+Sat+S]]</Say>, <Say>[[t+S;at+S;]]</Say> - <Say>[t͡ʃat͡ʃ]</Say>, <Say>[t͡ʃʲat͡ʃʲ]</Say>, <Say>[t͡ɕat͡ɕ]</Say></li>
      <li><Say>[[d+Zad+Z]]</Say>, <Say>[[d+Z;ad+Z;]]</Say> - <Say>[d͡ʒad͡ʒ]</Say>, <Say>[d͡ʒʲad͡ʒʲ]</Say>, <Say>[d͡ʑad͡ʑ]</Say></li>
      <li><Say>[[nan]]</Say>, <Say>[[n;an;]]</Say>, <Say>[[n^an^]]</Say> - <Say>[nan]</Say>, <Say>[nʲanʲ]</Say>, <Say>[ɲaɲ]</Say></li>
      <li><Say>[[lal]]</Say>, <Say>[[l;al;]]</Say>, <Say>[[l^al^]]</Say> - <Say>[lal]</Say>, <Say>[lʲalʲ]</Say>, <Say>[ʎaʎ]</Say></li>
      <li><Say>[[RaR]]</Say>, <Say>[[R;aR;]]</Say>         - <Say>[rar]</Say>, <Say>[rʲarʲ]</Say>, <Say>[rarʲ]</Say></li>
      <li><Say>[[kuk]]</Say>, <Say>[[k;uk;]]</Say>         - <Say>[kuk]</Say>, <Say>[kʲukʲ]</Say>, <Say>[kukʲ]</Say></li>
      <li><Say>[[tat]]</Say>, <Say>[[t;at;]]</Say>         - <Say>[tat]</Say>, <Say>[tʲatʲ]</Say>, <Say>[tatʲ]</Say></li>
    </ul>

    <p><a href="https://en.wikipedia.org/wiki/Palatalization_(phonetics)">wikipedia reference</a></p>

    <ul>
      <li>большой <Say>[bɐlʲˈʂoj]</Say> -
        <PlayUrl url="https://upload.wikimedia.org/wikipedia/commons/transcoded/4/47/Ru-%D0%B1%D0%BE%D0%BB%D1%8C%D1%88%D0%BE%D0%B9.ogg/Ru-%D0%B1%D0%BE%D0%BB%D1%8C%D1%88%D0%BE%D0%B9.ogg.mp3" />
        , <Say>[bɐljˈʂoj]</Say>
      </li>
      <li>царь <Say>[ˈtsærʲ]</Say> -
        <PlayUrl url="https://upload.wikimedia.org/wikipedia/commons/transcoded/9/98/Ru-%D1%86%D0%B0%D1%80%D1%8C.ogg/Ru-%D1%86%D0%B0%D1%80%D1%8C.ogg.mp3" />
        , <Say>[tsærj]</Say>
      </li>
      <li>Катя <Say>[ˈkatʲɐ]</Say> -
        <PlayUrl url="https://upload.wikimedia.org/wikipedia/commons/transcoded/4/44/Ru-%D0%9A%D0%B0%D1%82%D1%8F.ogg/Ru-%D0%9A%D0%B0%D1%82%D1%8F.ogg.mp3" />
        , <Say>[ˈkatjɐ]</Say>
      </li>
      <li>нёс <Say>[ˈnʲos]</Say> -
        <PlayUrl url="https://upload.wikimedia.org/wikipedia/commons/transcoded/2/28/Ru-%D0%BD%D1%91%D1%81.ogg/Ru-%D0%BD%D1%91%D1%81.ogg.mp3" />
        , <Say>[ˈnos]</Say>, <Say>[ˈnjos]</Say>
      </li>
      <li>beo <Say>[ˈbʲoː]</Say> -
        <PlayUrl url="https://upload.wikimedia.org/wikipedia/commons/transcoded/e/ed/Ga-beo.ogg/Ga-beo.ogg.mp3" />
        , <Say>[ˈboː]</Say>, <Say>[ˈbjoː]</Say>
      </li>
      <li>ответить <Say>[ɐˈtvʲitʲitʲ]</Say> -
        <PlayUrl url="https://upload.wikimedia.org/wikipedia/commons/transcoded/5/51/Ru-%D0%BE%D1%82%D0%B2%D0%B5%D1%82%D0%B8%D1%82%D1%8C.ogg/Ru-%D0%BE%D1%82%D0%B2%D0%B5%D1%82%D0%B8%D1%82%D1%8C.ogg.mp3" />
        , <Say>[ɐˈtvʲitʲitj]</Say>
      </li>
      <li>несёт <Say>[ˈnʲisʲot]</Say> -
        <PlayUrl url="https://upload.wikimedia.org/wikipedia/commons/transcoded/c/cb/Ru-%D0%BD%D0%B5%D1%81%D1%91%D1%82.ogg/Ru-%D0%BD%D0%B5%D1%81%D1%91%D1%82.ogg.mp3" />
        , <Say>[ˈnjisjot]</Say>
      </li>
      <li><Say>[ˈban]</Say>, <Say>[ˈbanʲ]</Say> -
        <PlayUrl url="https://upload.wikimedia.org/wikipedia/commons/8/89/Ro-ban-bani.ogg" />
      </li>
    </ul>
  </>)
}
